(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskFilterAddEdit',
	};

	var form_id = 'taskfilteraddedit-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var picker_color = '#0080c5';
		var tag_ids      = [];

		if ($('#' + form_id + 'existing_color').val()) {
			picker_color = $('#' + form_id + 'existing_color').val();
		}

		// checking the include on dashboard checkbox
		$('#' + form_id + 'on_dashboard').change(function onCheckboxChange(e)
		{
			var checked = $(this).is(':checked');

			if (checked) {
				$('.filter-color-field').removeClass('hidden');
			} else {
				$('.filter-color-field').addClass('hidden');
			}
		});

		// checking the include completed tasks checkbox
		$('#' + form_id + 'include_completed').change(function onCheckboxChange(e)
		{
			var checked = $(this).is(':checked');

			if (checked) {
				$('.completed-date-field').removeClass('hidden');
			} else {
				$('.completed-date-field').addClass('hidden');
			}
		});

		// init color picker
		$('#colorpicker').spectrum({
			color      : picker_color,
			showInitial: true,
			showInput  : true,
			change     : function changeColor(color) {
				var new_color = color.toHexString().toUpperCase();
				$('#' + form_id + 'filter_color').val(new_color);
			}
		});

		$('#' + form_id + 'on_dashboard').trigger('change');
		$('#' + form_id + 'include_completed').trigger('change');

		// adding task tags
		Adzuki.TaskManager.initTaskTagFields(form_id);

		// display "match all tags" field, only applies on this screen
		if ($('#' + form_id + 'tag_ids').val() !== '') {
			tag_ids = $('#' + form_id + 'tag_ids').val().split(',');

			if (tag_ids.length > 1) {
				$('.' + form_id + 'match-tags').removeClass('hidden');
			}
		}
	};
}(jQuery, window.Adzuki || {}));
